import { apiBusMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const busMapApiRoutes = {
    lines:                      apiBusMapBaseURL + "lines/",
    linesTransportAuthority:    apiBusMapBaseURL + "lines/ta/",
    stops:                      apiBusMapBaseURL + "stops/",
    stopsTransportAuthority:    apiBusMapBaseURL + "stops/ta/",
    generate:                   apiBusMapBaseURL + "generate/",
    generateTransportAuthority: apiBusMapBaseURL + "generate/ta/",
    list:                       apiBusMapBaseURL + "list/",
    listTransportAuthority:     apiBusMapBaseURL + "list/ta/",
};

export class BusMapAPI {
    static getAllLines(edition, provider = '') {
        const url = new URL(edition, busMapApiRoutes.lines);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getAllTransportAuthorityLines() {
        const url = busMapApiRoutes.linesTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getAllStops(edition, provider = '') {
        const url = new URL(edition, busMapApiRoutes.stops);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getAllTransportAuthorityStops() {
        const url = busMapApiRoutes.stopsTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static generate(edition, busMapStops, provider = '') {
        const url = busMapApiRoutes.generate;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify({
                "busMapStops": busMapStops,
                "networkEdition": edition
            })
        });
    }

    static generateTransportAuthority(busMapStops) {
        const url = busMapApiRoutes.generateTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify({
                "busMapStops": busMapStops
            })
        });
    }

    static list(provider = '') {
        const url = busMapApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listTransportAuthority() {
        const url = busMapApiRoutes.listTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/busmap/BusMapAPI.js